import { render, staticRenderFns } from "./BusinessItemCategoryDeleteConfirmationModal.vue?vue&type=template&id=507252ba"
import script from "./BusinessItemCategoryDeleteConfirmationModal.vue?vue&type=script&lang=js"
export * from "./BusinessItemCategoryDeleteConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports